import Text from "./Text";
import { useEffect, useRef } from "react";

const Pong = () => {
    const canvasRef = useRef(null);
    let width = 720 / 2
    let height = 480 / 2
    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");

        let touchY = null;
        let p1 = 80;
        let p2 = 200;
        const key = {};
        let ball = {
            x: width / 2,
            y: height / 2,
            speedX: 3,
            speedY: 0,
        };
        const aiSpeed = 2;

        const handleKeyDown = (e) => {
            key[e.keyCode] = true;
        };
        const handleKeyUp = (e) => {
            key[e.keyCode] = false;
        };
        const handleTouchStart = (e) => {
            touchY = e.touches[0].clientY;
        }
        const handleTouchMove = (e) => {
            const currentY = e.touches[0].clientY;
            const delta = currentY - touchY;
            touchY = currentY;
            p2 = Math.min(Math.max(p2 + delta, 0), 400);
        }

        document.addEventListener("keydown", handleKeyDown);
        document.addEventListener("keyup", handleKeyUp);
        canvas.addEventListener("touchstart", handleTouchStart);
        canvas.addEventListener("touchmove", handleTouchMove);

        function draw() {
            ctx.fillStyle = "black";
            ctx.fillRect(0, 0, width, height);
            ctx.fillStyle = "white";
            ctx.fillRect(10, p1, 10, 80);
            ctx.fillRect((width -20), p2, 10, 80);
            ctx.fillRect(ball.x, ball.y, 10, 10);
            requestAnimationFrame(draw);
        }

        function loop() {
            if (key[38]) p2 = Math.max(p2 - 5, 0);
            if (key[40]) p2 = Math.min(p2 + 5, 400);

            // AI
            if (ball.speedX < 0) {
                if (ball.y < p1 + 40) p1 = Math.max(p1 - aiSpeed, 0);
                else if (ball.y > p1 + 40) p1 = Math.min(p1 + aiSpeed, 400);
            }

            ball.x += ball.speedX;
            ball.y += ball.speedY;

            if (ball.x < 20 || ball.x > width - 30) {
                if (ball.x < 20 && ball.y > p1 && ball.y < p1 + 80) {
                    ball.speedX = -ball.speedX;
                    ball.speedY = (ball.y - p1 - 40) * 0.1;
                } else if (ball.x > width - 30 && ball.y > p2 && ball.y < p2 + 80) {
                    ball.speedX = -ball.speedX;
                    ball.speedY = (ball.y - p2 - 40) * 0.1;
                }
            }

            if (ball.y < 0 || ball.y > height -10) {
                ball.speedY = -ball.speedY;
            }

            if (ball.x < 0 || ball.x > width) {
                ball = {
                    x: width / 2,
                    y: height / 2,
                    speedX: ball.speedX < 0 ? 3 : -3,
                    speedY: 0,
                };
            }
        }

        draw();
        const interval = setInterval(loop, 1000 / 60);

        return () => {
            clearInterval(interval);
            document.removeEventListener("keydown", handleKeyDown);
            document.removeEventListener("keyup", handleKeyUp);
            canvas.removeEventListener("touchstart", handleTouchStart);
            canvas.removeEventListener("touchmove", handleTouchMove);
        };
    }, []);


    return (
        <div className="w-full flex flex-col justify-center">
            <Text type="maintitle" classNames={"text-center"} >Secret Pong</Text>
            <div className="flex w-full justify-center">
                <canvas
                    ref={canvasRef}
                    width={width}
                    height={height}
                    style={{ backgroundColor: "black" }}
                />
            </div>

        </div>
    )
}
export default Pong;